import { Component, inject, computed, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';

import { NotificationStore } from '../../../notifications/services/notification.store';
import { navigateToNotification } from '../../../notifications/utils/notification-routing';
import { ALERT_TYPE_ICON, ProximityAlert } from '../../../notifications/models/notification.model';
import { OsQuickpanelWidget } from '../../../../features/ordem-servico/components/os-quickpanel-widget/os-quickpanel-widget';
import { FeatureFlagService } from '../../../feature-flags';

@Component({
  selector: 'app-quickpanel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterModule,
    MatTabsModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    OsQuickpanelWidget,
  ],
  templateUrl: './quickpanel.html',
  styleUrl: './quickpanel.scss',
})
export class Quickpanel {
  private readonly store = inject(NotificationStore);
  private readonly router = inject(Router);
  readonly flagService = inject(FeatureFlagService);

  readonly notifications = computed(() => {
    const all = this.store.notifications();
    const unread = all.filter(n => !n.read);
    const read = all.filter(n => n.read);
    return [...unread, ...read].map(n => ({
      id: n.id,
      title: n.summary,
      subtitle: n.crimeType || n.location.description,
      time: n.elapsedTime || 'Agora',
      icon: ALERT_TYPE_ICON[n.alertType] || 'notifications',
      priority: n.priority === 'HIGH' || n.priority === 'URGENT' ? 'high' : 'low',
      read: n.read,
      original: n,
    }));
  });

  readonly shortcuts = computed(() => {
    const flags = this.flagService.flags();
    return [
      ...(flags.rap ? [{ label: 'Novo RAP', icon: 'description', route: '/rap/selecao-tipo' }] : []),
      ...(flags.provid ? [{ label: 'PROVID', icon: 'shield_person', route: '/provid/workspace' }] : []),
      ...(flags.consultaPessoa ? [{ label: 'Consultar Pessoa', icon: 'person_search', route: '/consultas/pessoa' }] : []),
      ...(flags.consultaVeiculo ? [{ label: 'Consultar Veículo', icon: 'directions_car', route: '/consultas/veiculo' }] : []),
      ...(flags.consultaBicicleta ? [{ label: 'Consultar Bicicleta', icon: 'pedal_bike', route: '/consultas/bicicleta' }] : []),
      ...(flags.consultaCelular ? [{ label: 'Consultar Celular', icon: 'smartphone', route: '/consultas/celular' }] : []),
      ...(flags.viaturaAbastecimento ? [{ label: 'Abastecimento', icon: 'local_gas_station', route: '/viatura/abastecimento' }] : []),
      ...(flags.viaturaVistoria ? [{ label: 'Vistoria', icon: 'fact_check', route: '/viatura/vistoria' }] : []),
      ...(flags.copom ? [{ label: 'Ver Chamados', icon: 'emergency', route: '/copom' }] : []),
      ...(flags.ordemServico ? [{ label: 'Ordem de Serviço', icon: 'task', route: '/ordem-servico' }] : []),
    ];
  });

  navigateShortcut(route: string): void {
    this.router.navigate([route]);
  }

  openNotification(notification: { original: ProximityAlert }): void {
    navigateToNotification(this.router, notification.original, this.store);
  }
}
